<mat-sidenav-container hasBackdrop="true" class="mx-auto p-0 -mt-px flex-auto border-t pt-0 sm:pt-0">
  <div class="mx-auto flex w-full flex-wrap p-4">
    <div class="flex flex-col sm:flex-row w-full mb-4 items-center justify-between">
      <div>
        <div class="flex items-center gap-1">
          <div hoverMenu hoverDelay="50" #hoverDirective="hoverMenu" [matMenuTriggerFor]="infoMenu">
            <button mat-icon-button color="primary">
              <mat-icon svgIcon="heroicons_outline:exclamation-circle"></mat-icon>
            </button>
          </div>

          <mat-menu [hasBackdrop]="false" [overlapTrigger]="false" class="w-full" #infoMenu="matMenu">
            <div class="p-4">
              <p>
                Crear un pedido nuevo. Confirma productos, cantidades,
                precios y fecha de entrega. Úsalo cuando el cliente ya
                decidió comprar.
              </p>
            </div>
          </mat-menu>
          <h2 class="text-xl font-semibold leading-8 tracking-tight">
            Pedidos
          </h2>
        </div>
        <div class="text-sm text-secondary font-medium tracking-tight">
          Genera un nuevo documento del tipo <b>pedido</b>.
        </div>
      </div>
      <div class="relative flex flex-0 flex-col px-4 py-2 sm:flex-row sm:items-center sm:justify-between">
        <div class="flex shrink-0">
          <!--<div class="text-3xl font-extrabold tracking-tight">Generación de Pedidos</div> -->
        </div>
        <div class="mt-6 flex shrink-0 items-center space-x-3 sm:ml-4 sm:mt-0">
          <mat-form-field style="width: 225px !important;" appearance="outline" style=" margin-bottom: -1.25em"
            *ngIf="quoteSelected || quoteLoaded">
            <mat-label>Cotización vinculada</mat-label>
            <mat-select [(ngModel)]="quoteLoaded" [ngModelOptions]="{standalone: true}">
              <mat-option *ngFor="let quote of quoteList" [value]="quote?._id">
                {{ quote?.serial }}
              </mat-option>
            </mat-select>
            <button mat-icon-button matSuffix aria-label="Clear selection" *ngIf="quoteLoaded"
              (click)="clearSelection()">
              <mat-icon>close</mat-icon>
            </button>
          </mat-form-field>
          <button mat-icon-button color="primary" (click)="newOrder()" matTooltip="Reiniciar">
            <mat-icon>refresh</mat-icon>
          </button>
        </div>
      </div>
    </div>
    <div class="bg-card flex flex-auto flex-col overflow-hidden rounded-2xl shadow xl:col-span-2 dark:bg-transparent">
      <!-- Main Content -->
      <div class="flex flex-auto overflow-scroll flex-col p-4">
        <mat-tab-group #tabGroup (selectedTabChange)="onTabChange($event)" style="height: 100%">
          <!-- Tab Datos Principales -->
          <mat-tab label="Cabecera">
            <div class="px-6 w-full flex flex-col shrink-0 items-center sm:flex-row sm:mt-0" style="padding-top: 24px;">
              <!-- Dropdown filters -->
              <form class="w-full flex flex-wrap" [formGroup]="formData">
                <div class="w-full section-container">
                  <div style="display: flex; justify-content: space-between; align-items: center;">
                    <h3 class="section-title">Datos generales</h3>
                    <button mat-button color="primary" (click)="nextHeader(tabGroup)" [disabled]="formData.invalid">
                      <mat-icon svgIcon="heroicons_solid:shopping-cart"></mat-icon>
                      <span class="ml-2">
                        Agregar productos
                      </span>
                    </button>
                  </div>
                  <div class="section-line"></div> <!-- Línea decorativa -->
                  <div class="w-full mt-4 grid grid-cols-1 gap-4 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-4">
                    <mat-form-field class="w-full">
                      <mat-label>Clase de pedido</mat-label>
                      <mat-select [formControl]="documentClassControl" name="documentClassId" required
                        (selectionChange)="onDocumentClassChange()">
                        <mat-option *ngFor="let documentClass of documentClassesList" [value]="documentClass._id"
                          class="text-content">
                          {{ documentClass.name }}
                        </mat-option>
                      </mat-select>
                      <mat-error *ngIf="documentClassControl.hasError('required')">
                        Este campo es obligatorio.
                      </mat-error>
                    </mat-form-field>

                    <mat-form-field class="w-full">
                      <mat-label>Oficina de venta</mat-label>
                      <mat-select [formControl]="salesOfficeControl" name="salesOfficeId" required
                        (selectionChange)="onSalesOfficeChange()" [disabled]="salesOfficeSelected">
                        <mat-option *ngFor="let salesOffice of salesOfficesList" [value]="salesOffice._id"
                          class="text-content">
                          {{ salesOffice.name }}
                        </mat-option>
                      </mat-select>
                      <mat-error *ngIf="salesOfficeControl.hasError('required')">
                        Este campo es obligatorio.
                      </mat-error>
                    </mat-form-field>

                    <mat-form-field class="w-full">
                      <mat-label>Condición de expedición</mat-label>
                      <mat-select [formControl]="expeditionConditionControl" name="expeditionConditionId"
                        [required]="expeditionConditionRequired" (selectionChange)="onExpeditionConditionChange()"
                        [disabled]="expeditionConditionDisabled">
                        <mat-option *ngFor="let expeditionCondition of expeditionConditionsList"
                          [value]="expeditionCondition._id" class="text-content">
                          {{ expeditionCondition.name }}
                        </mat-option>
                      </mat-select>
                      <mat-error *ngIf="expeditionConditionControl.hasError('required')">
                        Este campo es obligatorio.
                      </mat-error>
                    </mat-form-field>

                    <mat-form-field class="w-full">
                      <mat-label>Fecha de documento</mat-label>
                      <input matInput [matDatepicker]="documentDatePicker" [formControl]="documentDateControl"
                        [min]="today()">
                      <mat-datepicker-toggle matIconSuffix [for]="documentDatePicker"></mat-datepicker-toggle>
                      <mat-datepicker #documentDatePicker></mat-datepicker>
                      <mat-error *ngIf="documentDateControl.hasError('required')">
                        Este campo es obligatorio.
                      </mat-error>
                    </mat-form-field>
                  </div>
                  <div class="w-full mt-4 grid grid-cols-1 gap-4 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-2">
                    <mat-form-field class="w-full">
                      <mat-label>Solicitante</mat-label>
                      <input type="text" placeholder="Selecciona solicitante" aria-label="Selecciona solicitante"
                        matInput [formControl]="shipToControl" [matAutocomplete]="autoShipTo">
                      <mat-autocomplete #autoShipTo="matAutocomplete" [displayWith]="fetchShipToName"
                        (optionSelected)="onShipToChange()">
                        @for (shipTo of shipToList; track shipTo) {
                        <mat-option [value]="shipTo._id" class="text-content">
                          {{shipTo?.externalKeys?.code + ' - '}}{{ shipTo.name }}
                        </mat-option>
                        }
                      </mat-autocomplete>
                      <mat-error *ngIf="shipToControl.hasError('required')">
                        Este campo es obligatorio.
                      </mat-error>
                    </mat-form-field>

                    <div class="flex flex-col w-full">
                      <span class="text-black mb-4">
                        Pagador
                      </span>
                      <span *ngIf="soldToSelected?.parentName; else selectionPending" class="text-content">
                        {{ soldToSelected?.parentName }}
                      </span>
                    </div>

                    <mat-form-field class="w-full">
                      <mat-label>Dirección</mat-label>
                      <mat-select [formControl]="addressControl" name="addressId" [required]="addressRequired"
                        (selectionChange)="onAddressChange()">
                        <mat-option *ngFor="let address of addressesList" [value]="address._id" class="text-content">
                          {{address?.externalKeys?.code}} - {{ address.address }}
                        </mat-option>
                      </mat-select>
                      <mat-error *ngIf="addressControl.hasError('required')">
                        Este campo es obligatorio.
                      </mat-error>
                    </mat-form-field>

                    <mat-form-field class="w-full">
                      <mat-label>Referencia</mat-label>
                      <input type="text" placeholder="Referencia" aria-label="Referencia" matInput
                        [formControl]="referenceControl">
                    </mat-form-field>
                  </div>
                </div>

                <div class="w-full section-container">
                  <h3 class="section-title">Logistica</h3>
                  <div class="section-line"></div> <!-- Línea decorativa -->
                  <div class="w-full mt-4 grid grid-cols-1 gap-4 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4">
                    <mat-form-field class="w-full">
                      <mat-label>Almacén</mat-label>
                      <mat-select [formControl]="warehouseControl" name="warehouseControl" required
                        (selectionChange)="onWarehouseChange(); onGetStock()">
                        @for (warehouse of warehousesFilterList; track warehouse) {
                        <mat-option [value]="warehouse._id" class="text-content">
                          {{warehouse?.externalKeys?.code ? warehouse?.externalKeys?.code + ' - ' : ''}}{{
                          warehouse.name }}
                        </mat-option>
                        }
                      </mat-select>
                      <mat-error *ngIf="warehouseControl.hasError('required')">
                        Este campo es obligatorio.
                      </mat-error>
                    </mat-form-field>

                    <mat-form-field class="w-full" *ngIf="deliveryRouteRequired">
                      <mat-label>Ruta de entrega</mat-label>
                      <mat-select [formControl]="deliveryRouteControl" name="deliveryRouteControl"
                        [required]="deliveryRouteRequired" (selectionChange)="onDeliveryRouteChange()">
                        @for (deliveryRoute of deliveryRouteList; track deliveryRoute) {
                        <mat-option [value]="deliveryRoute._id" class="text-content">
                          {{ deliveryRoute.name }}
                        </mat-option>
                        }
                      </mat-select>
                      <mat-error *ngIf="deliveryRouteControl.hasError('required')">
                        Este campo es obligatorio.
                      </mat-error>
                    </mat-form-field>

                    <mat-form-field class="w-full">
                      <mat-label>Fecha de carga</mat-label>
                      <input matInput [matDatepicker]="chargeDatePicker" [formControl]="chargeDateControl"
                        [min]="today()" required>
                      <mat-datepicker-toggle matIconSuffix [for]="chargeDatePicker"></mat-datepicker-toggle>
                      <mat-datepicker #chargeDatePicker></mat-datepicker>
                      <mat-error *ngIf="chargeDateControl.hasError('required')">
                        Este campo es obligatorio.
                      </mat-error>
                    </mat-form-field>

                    <mat-form-field class="w-full">
                      <mat-label>Fecha de entrega</mat-label>
                      <input matInput [matDatepicker]="deliveryDatePicker" [formControl]="deliveryDateControl"
                        [min]="today()">
                      <mat-datepicker-toggle matIconSuffix [for]="deliveryDatePicker"></mat-datepicker-toggle>
                      <mat-datepicker #deliveryDatePicker></mat-datepicker>
                      <mat-error *ngIf="deliveryDateControl.hasError('required')">
                        Este campo es obligatorio.
                      </mat-error>
                    </mat-form-field>

                    <mat-form-field class="w-full">
                      <mat-label>Hora de entrega</mat-label>
                      <mat-icon matSuffix>schedule</mat-icon>
                      <input matInput placeholder="Hora de entrega" required aria-label="Hora de entrega"
                        [formControl]="deliveryHourControl" [ngxTimepicker]="default" />
                      <ngx-material-timepicker #default></ngx-material-timepicker>
                      <mat-error *ngIf="deliveryHourControl.hasError('required')">
                        Este campo es obligatorio.
                      </mat-error>
                    </mat-form-field>
                  </div>
                </div>

                <div class="w-1/2 section-container pr-2">
                  <h3 class="section-title">Facturación</h3>
                  <div class="section-line"></div> <!-- Línea decorativa -->
                  <div class="w-full mt-4 mb-4 grid grid-cols-1 gap-4 sm:grid-cols-2">
                    <div class="flex flex-col w-full">
                      <span class="text-black mb-4">
                        Moneda
                      </span>
                      <span *ngIf="selectedCurrency?.name; else selectionPending" class="text-content">
                        {{ selectedCurrency?.name }}
                      </span>
                    </div>

                    <mat-form-field class="w-full">
                      <mat-label>Condición de pago</mat-label>
                      <mat-select [formControl]="paymentConditionControl" name="paymentConditionId" required
                        (selectionChange)="onPaymentConditionChange()" [disabled]="paymentConditionDisabled">
                        <mat-option *ngFor="let paymentCondition of paymentConditionsFilterList"
                          [value]="paymentCondition._id" class="text-content">
                          {{paymentCondition?.externalKeys?.code}} - {{ paymentCondition.name }}
                        </mat-option>
                      </mat-select>
                      <mat-error *ngIf="paymentConditionControl.hasError('required')">
                        Este campo es obligatorio.
                      </mat-error>
                    </mat-form-field>
                  </div>
                </div>

                <div class="w-1/2 section-container pl-2">
                  <h3 class="section-title">Comisiones</h3>
                  <div class="section-line"></div> <!-- Línea decorativa -->
                  <div class="w-full mt-4 grid grid-cols-1 gap-4 sm:grid-cols-1">
                    <mat-form-field class="w-full">
                      <mat-label>Vendedor</mat-label>
                      <mat-select [formControl]="salesForceControl" name="salesForceControl"
                        (selectionChange)="onSalesForcesChange()" [required]="salesForceRequired">
                        @for (seller of salesForcesFilterList; track seller) {
                        <mat-option [value]="seller.masterUserId" class="text-content">
                          {{ seller.first_name }} {{seller.last_name}}
                        </mat-option>
                        }
                      </mat-select>
                      <mat-error *ngIf="salesForceControl.hasError('required')">
                        Este campo es obligatorio.
                      </mat-error>
                    </mat-form-field>
                  </div>
                </div>

                <div class="w-full section-container">
                  <div class="w-full">
                    <mat-form-field class="w-full">
                      <mat-label>Observaciones</mat-label>
                      <textarea placeholder="Observaciones" aria-label="Observaciones" matInput
                        [formControl]="comentariesControl"></textarea>
                    </mat-form-field>
                  </div>
                </div>
              </form>
            </div>
          </mat-tab>
          <!-- Tab Datos Principales -->
          <mat-tab label="Lista de articulos" [disabled]="formData.invalid">
            <div class="px-3 pb-3 shrink-0 items-center top-filters"
              style="padding-top:24px; position: -webkit-sticky; position: sticky; top: 0px; z-index: 1;background-color: white;">
              <div class="left-section">
                <mat-form-field class="mx-1 my-1 custom-input fuse-mat-dense fuse-mat-rounded min-w-64 custom-width"
                  subscriptSizing="dynamic">
                  <!--<mat-icon class="icon-size-5" matPrefix svgIcon="heroicons_solid:magnifying-glass"></mat-icon>-->
                  <!--<button matPrefix mat-icon-button>
                                    <mat-icon>account_tree</mat-icon>
                                </button>-->
                  <mat-icon matPrefix svgIcon="heroicons_solid:magnifying-glass"></mat-icon>
                  <input matInput placeholder="Buscar" autocomplete="off" [formControl]="searchControl" />
                </mat-form-field>

                <mat-form-field class="mx-1 my-1 fuse-mat-dense fuse-mat-rounded min-w-64 custom-width"
                  subscriptSizing="dynamic">
                  <mat-label>Grupo de Materiales</mat-label>
                  <button color="primary" matSuffix mat-icon-button (click)="togglePopover($event)">
                    <mat-icon>account_tree</mat-icon>
                  </button>
                  <input matInput [(ngModel)]="filter.itemGroup.name" [readonly]="true">
                </mat-form-field>

                <mat-slide-toggle *ngIf="isProductAndStockCombined" [checked]="filter.withStock == true"
                  (change)="onWithStockChange($event.checked)" name="withStock" color="primary"
                  [(ngModel)]="filter.withStock" [ngModelOptions]="{standalone: true}">Con inventario</mat-slide-toggle>

                <div style="position: relative;">
                  <div *ngIf="isPopoverVisible" class="popover-container" #popover>
                    <mat-form-field class="w-full">
                      <mat-label>Buscar</mat-label>
                      <input matInput (input)="filterTree($event.target.value)" placeholder="Buscar ...">
                    </mat-form-field>
                    <mat-card-content style="min-width: 400px !; max-width: 800px; max-height:300px; overflow-y: auto;">
                      <mat-radio-group [(ngModel)]="filter.itemGroup" (change)="onRadioGroupClick($event)">
                        <mat-tree [dataSource]="dataSourceN1" [treeControl]="treeControl1">
                          <!-- Nodo sin hijos -->
                          <mat-tree-node *matTreeNodeDef="let node" matTreeNodePadding>
                            <li class="mat-tree-node">
                              <mat-radio-button [value]="node" style="font-size: 11px;" style="padding-left: 40px;">
                                {{ node.name }}
                              </mat-radio-button>
                            </li>
                          </mat-tree-node>

                          <!-- Nodo con hijos -->
                          <mat-tree-node *matTreeNodeDef="let node; when: hasChild" matTreeNodePadding>
                            <div class="mat-tree-node">
                              <button mat-icon-button matTreeNodeToggle [attr.aria-label]="'toggle ' + node.name">
                                <mat-icon>
                                  {{ treeControl1.isExpanded(node) ? 'expand_more' : 'chevron_right' }}
                                </mat-icon>
                              </button>
                              <mat-radio-button [value]="node" style="font-size: 11px;">
                                {{ node.name }}
                              </mat-radio-button>
                            </div>
                          </mat-tree-node>
                        </mat-tree>
                      </mat-radio-group>
                    </mat-card-content>
                  </div>
                </div>
              </div>

              <div class="right-button">
                <div>
                  <mat-slide-toggle [checked]="filter.showCart == true" (change)="onShowCartChange($event.checked)"
                    name="showCart" color="primary">Ver carrito</mat-slide-toggle>
                </div>

                <button mat-button color="primary" (click)="saveCart(tabGroup)">
                  <mat-icon style="font-size: 24px;">save</mat-icon>
                  <span class="ml-2">
                    Guardar
                  </span>
                </button>
              </div>
            </div>

            <div class="flex flex-auto flex-col overflow-auto">
              <div class="container mt-0 flex-auto flex-col">
                <table class="w-full table-fixed mat-elevation-z" mat-table [dataSource]="dataSource" matSort
                  (matSortChange)="changeSort($event)" matSortDisableClear multiTemplateDataRows
                  style="table-layout:fixed; width: 100%; margin-bottom: 25px;">
                  <ng-container matColumnDef="det">
                    <th mat-header-cell *matHeaderCellDef></th>
                    <td mat-cell *matCellDef="let element">
                      <button class="h-7 min-h-7 min-w-10 px-2 leading-6" (click)="toggleDetails(element)"
                        style="margin-left: 10px;">
                        <mat-icon class="icon-size-5"
                          [svgIcon]="selectedProduct?._id === element._id
                                                  ? 'heroicons_solid:chevron-up' : 'heroicons_solid:chevron-down' "></mat-icon>
                      </button>
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="product">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header class=" text-left first-col table-tittle">
                      Producto</th>
                    <td mat-cell *matCellDef="let element" class="text-left first-col product">
                      <b class="product-code">{{removeLeadingZeros(element.code)}}</b><br>
                      <span>{{element.name}}</span>
                      <span style="font-size: 13px;" *ngIf="element.barcode">
                        <br><mat-icon class="icon-size-5"
                          style="vertical-align: middle; padding-bottom: 2px;">view_week</mat-icon>
                        <b>{{element.barcode}}</b>
                      </span>
                      <span style="font-size: 13px; margin-left: 10px;"
                        *ngIf="element.reference">Ref.:<b>{{element.reference}}</b></span>
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="productWarehouse">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-left first-col table-tittle">
                      Almacén</th>
                    <td mat-cell *matCellDef="let element" class="text-left first-col"
                      style="padding: 0; line-height: inherit;">
                      <div
                        style="display: flex; flex-direction: column; justify-content: space-between; height: 100%; padding: 8px 0; ">
                        <span style="margin: 0;">&nbsp;</span>
                        <span style="margin-top: 5px; margin-bottom: 5px;">{{
                          getNameWarehouse(element.productWarehouseId) }}</span>
                        <span style="font-size: 12px; font-weight: 500; margin-bottom: -2px;">
                          Disponible: <b>{{ getFormattedStock(element) }}
                            {{element?.productAlternalUnitOfMeasuresSelected?.unitOfMeasure?.code}}</b>
                        </span>
                      </div>
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="quantity">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header class=" text-left first-col table-tittle">
                      Cantidad</th>
                    <td mat-cell *matCellDef="let element" class=" text-left first-col table-text">
                      <mat-form-field class="mt-2 w-full" appearance="fill" floatLabel="never">
                        <input matInput type="number" [(ngModel)]="element.productQuantity"
                          [step]="getStepValue(element)" [min]="0" placeholder="Cantidad" aria-label="Cantidad" matInput
                          (change)="onChangeQuantity(element)" (keyup)="onChangeQuantity(element)">
                        <mat-hint style="color: #1e293b !important;">Cnt.Deseada: <b>{{element?.soldQuantitySuggested ??
                            0}}</b></mat-hint>
                      </mat-form-field>
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="unitMeasure">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header class=" text-left first-col table-tittle">UM
                    </th>
                    <td mat-cell *matCellDef="let element" class=" text-left first-col table-text">
                      <mat-form-field class="mt-2 w-full" appearance="fill" floatLabel="never">
                        <mat-select [(ngModel)]="element.productUnitMeasureId" name="productUnitMeasureId" required
                          (selectionChange)="onUnitMeasureChange(element); onChangePrice(element); onChangeStock(element)">
                          @for (um of element.alternalUnitOfMeasures; track um) {
                          @if(um && um.unitOfMeasure){
                          <mat-option [value]="um.unitOfMeasure._id">
                            {{ um.unitOfMeasure?.name }}
                          </mat-option>
                          }
                          }
                        </mat-select>
                      </mat-form-field>
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="umVariants">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header class=" text-left first-col table-tittle">
                      Conversión</th>
                    <td mat-cell *matCellDef="let element" class=" text-left first-col ">
                      <app-unit-measure-display
                        [baseUnit]="{
                          quantity: element.productQuantityUMB,
                          unitId: element.productUMB?.unitOfMeasure?._id,
                          unitName: element.productUMB?.unitOfMeasure?.name,
                          unitAbbreviation: element.productUMB?.unitOfMeasure?.code
                        }"
                        [parallelUnit]="{
                          quantity: element.productQuantityUMP,
                          unitId: element.productUMP?.unitOfMeasure?._id,
                          unitName: element.productUMP?.unitOfMeasure?.name,
                          unitAbbreviation: element.productUMP?.unitOfMeasure?.code
                        }"
                        [material]="{
                          _id: element._id,
                          code: element.code,
                          UMPActive: element.UMPActive
                        }"
                        [companyUMPActive]="company?.UMPActive"
                        [statusId]="element.statusId"
                      ></app-unit-measure-display>
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="price">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header class=" text-left first-col table-tittle">
                      Precio ({{selectedCurrency?.code}}.)</th>
                    <td mat-cell *matCellDef="let element" class=" text-left first-col ">
                      {{ element?.priceToShow | number: '1.2-2'}}
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="subtotal">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header class=" text-left first-col table-tittle">
                      Subtotal ({{selectedCurrency?.code}}.)</th>
                    <td mat-cell *matCellDef="let element" class=" text-left first-col ">
                      {{ element?.productSubTotal | number: '1.2-2' }}
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="expandedDetail">
                    <td mat-cell *matCellDef="let element" [attr.colspan]="displayedColumns.length"
                      style="width: 100%;">
                      <tr *ngIf="selectedProduct?._id === element._id" class="details-row p-3">
                        <td [attr.colspan]="displayedColumns.length">
                          <ng-container
                            *ngTemplateOutlet="rowDetailsTemplate; context: { $implicit: row }"></ng-container>
                        </td>
                      </tr>
                    </td>
                  </ng-container>

                  <!-- Header Row -->
                  <tr mat-header-row *matHeaderRowDef="displayedColumns"
                    class="sticky top-0 z-10  bg-white dark:bg-gray-900"></tr>

                  <!-- Fila principal -->
                  <tr mat-row *matRowDef="let element; columns: displayedColumns;" class="border-b"
                    [class.table-expanded-row]="selectedProduct?._id === element._id"></tr>

                  <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="table-detail-row"></tr>

                </table>
              </div>
              <div *ngIf="this.dataSource.length === 0" class="border-t p-8 text-center text-1xl sm:p-10">Lo sentimos,
                no hay registros para mostrar.
              </div>
            </div>
          </mat-tab>
          <mat-tab label="Resumen del pedido" [disabled]="formData.invalid || !isValidDetail">
            <div style="padding-top: 24px; height: calc(100vh - 100px);">
              <!--Cabecera-->
              <div class="px-6 w-full flex flex-col shrink-0 items-center sm:flex-row sm:mt-0">
                <div class="w-full flex flex-wrap">
                  <div class="w-full mb-4 section-container">
                    <div style="display: flex; justify-content: space-between; align-items: center;">
                      <h3 class="section-title">Datos generales</h3>
                      <button mat-button color="primary" (click)="openConfirmationDialog()">
                        <mat-icon svgIcon="heroicons_solid:document-text"></mat-icon>
                        <span class="ml-2">
                          Generar pedido
                        </span>
                      </button>
                    </div>

                    <div class="section-line"></div> <!-- Línea decorativa -->
                    <div class="w-full mt-4 grid grid-cols-1 gap-4 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4">
                      <div class="flex flex-col w-full">
                        <span class="text-black mb-2">
                          <b>Clase de pedido</b>
                        </span>
                        <span>
                          {{documentClassSelected?.name}}
                        </span>
                      </div>

                      <div class="flex flex-col w-full">
                        <span class="text-black mb-2">
                          <b>Oficina de venta</b>
                        </span>
                        <span>
                          {{salesOfficeSelected?.name}}
                        </span>
                      </div>

                      <div class="flex flex-col w-full">
                        <span class="text-black mb-2">
                          <b>Condición de expedición</b>
                        </span>
                        <span>
                          {{expeditionConditionSelected?.name}}
                        </span>
                      </div>

                      <div class="flex flex-col w-full">
                        <span class="text-black mb-2">
                          <b>Solicitante</b>
                        </span>
                        <span>
                          {{shipToSelected?.name}}
                        </span>
                      </div>

                      <div class="flex flex-col w-full">
                        <span class="text-black mb-2">
                          <b>Pagador</b>
                        </span>
                        <span>
                          {{soldToSelected?.parentName}}
                        </span>
                      </div>

                      <div class="flex flex-col w-full">
                        <span class="text-black mb-2">
                          <b>Dirección</b>
                        </span>
                        <span>
                          {{addressSelected?.address}}
                        </span>
                      </div>

                      <div class="flex flex-col w-full">
                        <span class="text-black mb-4">
                          <b>Fecha de documento</b>
                        </span>
                        <span>
                          {{formatDate(this.documentDateControl.value)}}
                        </span>
                      </div>

                      <div class="flex flex-col w-full">
                        <span class="text-black mb-4">
                          <b>Referencia</b>
                        </span>
                        <span>
                          {{this.referenceControl.value}}
                        </span>
                      </div>
                    </div>
                  </div>

                  <div class="w-full mb-4 section-container">
                    <h3 class="section-title">Logistica</h3>
                    <div class="section-line"></div> <!-- Línea decorativa -->
                    <div class="w-full mt-4 grid grid-cols-1 gap-4 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4">
                      <div class="flex flex-col w-full">
                        <span class="text-black mb-4">
                          <b>Almacén</b>
                        </span>
                        <span>
                          {{warehouseSelected?.name}}
                        </span>
                      </div>

                      <div class="flex flex-col w-full">
                        <span class="text-black mb-4">
                          <b>Ruta de entrega</b>
                        </span>
                        <span>
                          {{deliveryRouteSelected?.name}}
                        </span>
                      </div>

                      <div class="flex flex-col w-full">
                        <span class="text-black mb-4">
                          <b>Fecha de carga</b>
                        </span>
                        <span>
                          {{formatDate(this.chargeDateControl.value)}}
                        </span>
                      </div>

                      <div class="flex flex-col w-full">
                        <span class="text-black mb-4">
                          <b>Fecha de entrega</b>
                        </span>
                        <span>
                          {{formatDate(this.deliveryDateControl.value)}}
                          <mat-icon *ngIf="systemSuggestedDate" class="icon-size-5 color-icon-alert" matPrefix
                            svgIcon="heroicons_solid:light-bulb" (click)="openSuggestedDateDialog()"></mat-icon>
                        </span>
                      </div>

                      <div class="flex flex-col w-full">
                        <span class="text-black mb-4">
                          <b>Hora de entrega</b>
                        </span>
                        <span>
                          {{this.deliveryHourControl.value}}
                        </span>
                      </div>
                    </div>
                  </div>

                  <div class="w-1/2 mb-4 section-container pr-2">
                    <h3 class="section-title">Facturación</h3>
                    <div class="section-line"></div> <!-- Línea decorativa -->
                    <div class="w-full mt-4 mb-4 grid grid-cols-1 gap-4 sm:grid-cols-2">
                      <div class="flex flex-col w-full">
                        <span class="text-black mb-4">
                          <b>Moneda</b>
                        </span>
                        <span>
                          {{selectedCurrency?.name}}
                        </span>
                      </div>

                      <div class="flex flex-col w-full">
                        <span class="text-black mb-4">
                          <b>Condición de pago</b>
                        </span>
                        <span>
                          {{paymentConditionSelected?.name}}
                        </span>
                      </div>
                    </div>
                  </div>

                  <div class="w-1/2 mb-4 section-container pl-2">
                    <h3 class="section-title">Comisiones</h3>
                    <div class="section-line"></div> <!-- Línea decorativa -->
                    <div class="w-full mt-4 mb-4 grid grid-cols-1 gap-4 sm:grid-cols-2">
                      <div class="flex flex-col w-full">
                        <span class="text-black mb-4">
                          <b>Vendedor</b>
                        </span>
                        <span>
                          {{salesForceSelected?.first_name}} {{salesForceSelected?.last_name}}
                        </span>
                      </div>

                      <div class="flex flex-col w-full">
                        <span class="text-black mb-4">
                          <b>Observaciones</b>
                        </span>
                        <span>
                          {{this.comentariesControl.value}}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div style="position: -webkit-sticky; position: sticky; top: 50px; z-index: 1;background-color: white;">
                <table class="table-det">
                  <tr>
                    <td>Total de productos</td>
                    <td class="text-right">{{ selectedCurrency?.code }}. {{ (subTotal | decimalFormat) }}</td>
                  </tr>
                  <tr>
                    <td>Subtotal</td>
                    <td class="text-right">{{ selectedCurrency?.code }}. {{ (subTotalBeforeTaxes | decimalFormat) }}
                    </td>
                  </tr>
                  <tr>
                    <td>Impuesto</td>
                    <td class="text-right">{{ selectedCurrency?.code }}. {{ totalTaxes | decimalFormat }}</td>
                  </tr>
                  <tr>
                    <td>Total a pagar</td>
                    <td class="text-right">{{ selectedCurrency?.code }}. {{ (total | decimalFormat) }}</td>
                  </tr>
                </table>
              </div>

              <!--Detalle-->
              <div>
                <table class="min-w-500 overflow-y-visible mat-elevation-z" mat-table [dataSource]="dataSourceOrder">
                  <ng-container matColumnDef="code">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-left">Material</th>
                    <td mat-cell *matCellDef="let element" class="text-left product text-content">
                      <b class="product-code">{{removeLeadingZeros(element.code)}}</b><br>
                      {{element.name}}
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="productWarehouseId">
                    <th mat-header-cell *matHeaderCellDef class="px-6 text-left">Almacén</th>
                    <td mat-cell *matCellDef="let element" class="px-6 text-left text-content">
                      {{getNameWarehouse(element.productWarehouseId)}}
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="selectMeasure">
                    <th mat-header-cell *matHeaderCellDef class="px-6 text-left"> UM </th>
                    <td mat-cell *matCellDef="let element" class="px-6 text-left">
                      {{getNameMeasure(element,element.productUnitMeasureId)}}
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="productQuantity">
                    <th mat-header-cell *matHeaderCellDef class="px-6 text-left"> Cantidad </th>
                    <td mat-cell *matCellDef="let element" class="px-6 text-left">
                      {{element?.productQuantity}}
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="price">
                    <th mat-header-cell *matHeaderCellDef class="px-6 text-left"> Precio ({{selectedCurrency?.code}}.)
                    </th>
                    <td mat-cell *matCellDef="let element" class="px-6 text-left">
                      {{ element?.priceToShow | number: '1.2-2'}}
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="productSubTotal">
                    <th mat-header-cell *matHeaderCellDef class="px-6 text-left"> Subtotal ({{selectedCurrency?.code}}.)
                    </th>
                    <td mat-cell *matCellDef="let element" class="px-6 text-left">
                      {{ element?.productSubTotal | number: '1.2-2' }}
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="action">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header></th>
                    <td mat-cell *matCellDef="let element;let i = index;">
                      <div class="text-content">
                        <button mat-icon-button (click)="onDelete(i)">
                          <mat-icon color="warn">delete</mat-icon>
                        </button>
                      </div>
                    </td>
                  </ng-container>

                  <tr mat-header-row *matHeaderRowDef="displayedColumnsOrder" class="bg-gray-100 dark:bg-gray-900"></tr>
                  <tr mat-row *matRowDef="let row; columns: displayedColumnsOrder;" class="border-b"></tr>
                </table>
              </div>
            </div>
          </mat-tab>
        </mat-tab-group>

        <!-- Paginación -->
        @if(isSecondTabActive){
        <mat-paginator
          class="z-10 border-b bg-gray-50 dark:bg-transparent sm:absolute sm:inset-x-0 sm:bottom-0 sm:border-b-0 sm:border-t"
          [pageSize]="pageSize" [pageSizeOptions]="[50, 100, 150, 200]" [length]="totalItems"
          [showFirstLastButtons]="true" (page)="changePage($event)"></mat-paginator>
        }
      </div>
    </div>
  </div>

  <!-- NG-TEMPLATES -->
  <ng-template #selectionPending>
    <span>
      Pendiente a seleccionar
    </span>
  </ng-template>

  <ng-template #rowDetailsTemplate let-product>
    <div style="max-width: 100%; min-width: 100%;">
      <form class="p-2 detail-container">
        <div class="px-2 flex flex-col w-full sm:w-1/2">
          <mat-form-field class="w-full">
            <mat-label>Almacén</mat-label>
            <mat-select [(ngModel)]="selectedProduct.productWarehouseId" [ngModelOptions]="{standalone: true}"
              (selectionChange)="onChangeStock(selectedProduct)">
              @for (wh of warehousesFilterList; track wh) {
              <mat-option [value]="wh._id">
                {{ wh.name }}
              </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>

        <div class="px-2 flex flex-col w-full sm:w-1/4">
          <span class="mb-1"><b>Unidad de medida</b></span>
          <span>U.M. Base: <b>{{selectedProduct?.productUMB?.unitOfMeasure?.name}}</b></span>
          <span *ngIf="selectedProduct.productUMP">UM Paralela:
            <b>{{selectedProduct?.productUMP?.unitOfMeasure?.name}}</b></span>
        </div>

        <div *ngIf="isStockRequired" class="px-2 flex flex-col w-full sm:w-1/4">
          <span class="mb-1"><b>Disponibilidad</b></span>
          <span>Disponible: <b>{{ getFormattedStock(selectedProduct) }}</b></span>
          <span>Cantidad Deseada: <b>{{ selectedProduct?.soldQuantitySuggested }}</b></span>
        </div>

        <mat-form-field class="px-2 flex w-full flex-col">
          <mat-label>Comentario</mat-label>
          <textarea placeholder="Comentario" aria-label="Comentario" matInput
            [(ngModel)]="selectedProduct.productComment" [ngModelOptions]="{standalone: true}"></textarea>
        </mat-form-field>
      </form>
    </div>
  </ng-template>

  <ng-template #orderSuggestedDateDialog let-data>
    <div class="flex items-start space-x-2 mb-4">
      <mat-icon svgIcon="heroicons_outline:check-circle" class="text-green-500 ml-4 mt-6"
        style="font-size: 32px;"></mat-icon>
      <div class="grid">
        <h2 mat-dialog-title class="text-lg font-bold mb-1">Fecha sugerida</h2>
      </div>
    </div>
    <div class="px-6 grid">
      <span>El sistema le sugieré la siguiente fecha:</span>
      <span style="font-size: 16px; text-align: center;"><b>{{formatDate(systemSuggestedDate)}}</b></span>
      <span>¿Desea utilizar la fecha sugerida por el sistema?</span>
    </div>
    <mat-dialog-actions class="modal-actions flex justify-end">
      <button mat-raised-button color="warn" [mat-dialog-close]="true">No</button>
      <button mat-button mat-dialog-close class="align-left" (click)="changeSuggestedDate()">Si</button>
    </mat-dialog-actions>
  </ng-template>

  <ng-template #orderFinalizedDialog let-data>
    <div class="flex items-start space-x-2 mb-4">
      <div class="flex items-center">
        <mat-icon svgIcon="heroicons_outline:check-circle" class="text-green-500 ml-4 mt-6"
          style="font-size: 32px;"></mat-icon>
      </div>
      <div class="grid">
        <h2 mat-dialog-title class="text-lg font-bold mb-1">Pedido Finalizado</h2>
      </div>
    </div>
    <mat-dialog-actions class="modal-actions flex justify-end">
      <button mat-button mat-dialog-close class="align-left" (click)="redirectList()">Ver pedidos</button>
      <button mat-raised-button color="warn" [mat-dialog-close]="true">Generar nuevo pedido</button>
    </mat-dialog-actions>
  </ng-template>

  <ng-template #orderConfirmationDialog let-data>
    <div class="flex items-start space-x-2 mb-4">
      <div class="flex items-center">
        <mat-icon svgIcon="heroicons_outline:exclamation-triangle" class="text-yellow-500 ml-4 mt-6"
          style="font-size: 32px"></mat-icon>
      </div>
      <div class="grid">
        <h2 mat-dialog-title class="text-lg font-bold mb-1">
          Confirmar Generación
        </h2>
        <mat-dialog-content class="modal-content mt-0">
          <p>¿Está seguro que desea generar el pedido?</p>
        </mat-dialog-content>
      </div>
    </div>
    <mat-dialog-actions class="modal-actions flex justify-end">
      <button mat-button mat-dialog-close class="align-left">
        Cancelar
      </button>
      <button mat-raised-button color="warn" [mat-dialog-close]="true">
        Aceptar
      </button>
    </mat-dialog-actions>
  </ng-template>

  <ng-template #orderStockDialog let-data>
    <div class="flex items-start space-x-2 mb-4">
      <div class="flex items-center">
        <mat-icon svgIcon="heroicons_outline:exclamation-triangle" class="text-yellow-500 ml-4 mt-6"
          style="font-size: 32px"></mat-icon>
      </div>
      <div class="grid w-full">
        <h2 mat-dialog-title class="text-lg font-bold mb-1">
          Disponibilidad
        </h2>
        <mat-dialog-content class="modal-content mt-0">
          <p>No se dispone de suficiente cantidad para los siguientes productos:</p>
          <table class="table-det">
            <tr>
              <td><b>Producto</b></td>
              <td><b>Cnt.deseada</b></td>
              <td><b>Disponible</b></td>
            </tr>
            <tr *ngFor="let sp of stockErrorProducts">
              <td>{{sp.name}}</td>
              <td>Cantidad deseada: <b>{{sp.soldQuantitySuggested}}</b></td>
              <td>Cantidad disponible: <b>{{sp.productStock?.availableStock ?? 0}}</b></td>
            </tr>
          </table>
        </mat-dialog-content>
      </div>
    </div>
    <mat-dialog-actions class="modal-actions flex justify-end">
      <span></span>
      <button mat-raised-button color="warn" [mat-dialog-close]="true">
        Aceptar
      </button>
    </mat-dialog-actions>
  </ng-template>

  <ng-template #orderErrorDialog let-data>
    <div class="flex items-start space-x-2 mb-4">
      <div class="flex items-center">
        <mat-icon svgIcon="heroicons_outline:exclamation-triangle" class="text-red-500 ml-4 mt-6"
          style="font-size: 32px"></mat-icon>
      </div>
      <div class="grid w-full">
        <h2 mat-dialog-title class="text-lg font-bold mb-1">
          Error
        </h2>
        <mat-dialog-content class="modal-content mt-0">
          <p>Se encontraron los siguientes errores al generar la orden:</p>
          <table class="table-det">
            <tr>
              <td><b>Código</b></td>
              <td><b>Descripción</b></td>
            </tr>
            <tr *ngFor="let oe of orderErrorList">
              <td>{{oe.entity}}</td>
              <td>{{errorDictionary[oe.entity] ?? 'Descripción no disponible'}}</td>
            </tr>
          </table>
        </mat-dialog-content>
      </div>
    </div>
    <mat-dialog-actions class="modal-actions flex justify-end">
      <span></span>
      <button mat-raised-button color="warn" [mat-dialog-close]="true">
        Aceptar
      </button>
    </mat-dialog-actions>
  </ng-template>

</mat-sidenav-container>